import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { ApiService } from '../../shared/services/api.service';
import { Agency } from '../../models/agency.model';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-header',
  imports: [RouterLinkActive, RouterLink, NgClass, NgForOf, NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  navLinks = [
    { label: 'Dashboard', path: '/dashboard', icon: 'ri-dashboard-line' },
    { label: 'Providers', path: '/providers', icon: 'ri-plane-line' },
    { label: 'Applications', path: '/applications', icon: 'ri-apps-line' },
    { label: 'Reports', path: '/reports', icon: 'ri-bar-chart-line' },
    { label: 'Settings', path: '/settings', icon: 'ri-settings-3-line' },
  ];
  currentAgency?: Agency;
  agencies: Agency[] = [];
  isLogged: boolean = false;
  registerAvailable = environment.registerAvailable;

  constructor(
    private apiService: ApiService,
    public authService: AuthService,
    protected ls: LocalStorageService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private keycloak: Keycloak
  ) {}

  ngOnInit() {
    this.isLogged = !!this.keycloak.authenticated;
    this.initUserDataSubscription();
    this.displayStoredNotification();
  }

  private initUserDataSubscription(): void {
    this.authService.isUserDataReceived$.subscribe(() => {
      this.getAgencies();
    });
  }

  private displayStoredNotification(): void {
    const message = this.ls.getItem('notificationMessage');
    if (message) {
      this.toastr.success(message, 'Success');
      this.ls.removeItem('notificationMessage');
    }
  }

  getAgencies(): void {
    this.apiService.getAgencies().subscribe({
      next: (agencies: Agency[]) => {
        if (agencies?.length) {
          this.currentAgency = agencies.find(
            (agency: Agency) => agency.id === this.ls.getItem('agencyID')
          );

          this.agencies = agencies
            .filter(agency => agency.role === 'manager')
            .sort((a: Agency, b: Agency) => {
              if (a.id === this.currentAgency?.id) return -1;
              if (b.id === this.currentAgency?.id) return 1;

              return a.name.localeCompare(b.name);
            });

          this.cdr.markForCheck();
        }
      },
      error: err => console.log(err),
    });
  }

  switchAgency(agency: Agency): void {
    this.ls.setItem('agency', agency.name);
    this.ls.setItem('notificationMessage', 'Agency switched');
    window.location.reload();
  }

  openAccountSettings() {
    const url = `${environment.keycloakUrl}/realms/agents/account/#/security/signingin`;
    window.open(url, '_blank');
  }

  login(): void {
    this.keycloak.login({ redirectUri: window.location.origin });
  }
}
